<template>
  <section class="global-toast-group">
    <transition-group name="fade" tag="div" class="global-toast-group__array">
      <VToastGroupItem
        v-for="toast in events"
        :key="toast.id"
        :type="toast.type"
        :title="toast.title"
        :content="toast.content"
        :timestamp="toast.id"
      />
    </transition-group>
  </section>
</template>

<script setup>
import { ref, watch, inject } from "vue";
import VToastGroupItem from "./VToastGroupItem.vue";

const toastEvents = inject("toastEvents");

const events = ref(toastEvents);

watch(
  () => events.value,
  () => {
    events.value = toastEvents;
  },
  { deep: true }
);
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-from, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.global-toast-group {
  position: absolute;
  z-index: 99999;
}

.global-toast-group__array {
  display: flex;
  flex-direction: column;
  position: fixed;
  color: var(--grey-base);
  border: 1px;
  border-radius: 8px;
  top: 90px;
  right: 20px;
}
</style>
